import { createContext } from 'react';
import type { IUserAvatarPreview } from './UserAvatarPreviewModal';

/** Вложенная карточка открывает фотографию у владельца внешней карточки, вне всех её дропдаунов. */
const UserAvatarPreviewContext = createContext<((preview: IUserAvatarPreview) => void) | null>(null);

export default UserAvatarPreviewContext;
